import { useTranslation } from 'next-i18next'

import ExpressionNorwegianWithComma from './ExpressionNorweigianWithDecimal'
import ExpressionInternationalWithComma from './ExpressionInternationalWithComma'

export default function ExpressionWithComma({
  multiplier,
  multiplicand,
  maxAnswerLen,
}: {
  multiplier: string
  multiplicand: string
  maxAnswerLen: number
}): React.ReactElement {
  const { t } = useTranslation('bootcamp')
  const decimalSign = t('signs.decimal')

  if (decimalSign === ',') {
    return (
      <ExpressionNorwegianWithComma maxAnswerLen={maxAnswerLen} multiplicand={multiplicand} multiplier={multiplier} />
    )
  } else {
    return <ExpressionInternationalWithComma multiplicand={multiplicand} multiplier={multiplier} />
  }
}
